var SCAAFFCustomerReferSetting = {
    "program": {
        "active": false,
        "shop": "mahi-leather.myshopify.com",
        "incentive": {
            "type": "percentage",
            "value": "10.00",
            "price_rule_id": "",
            "coupon": ""
        },
        "program": "Nzk4MDI="
    },
    "design": {
        "refer_customer_button": {
            "refer_button_text": "Refer & Earn",
            "refer_background_color": "#1d85e8",
            "refer_text_color": "#ffffff",
            "web_position": "left-bottom",
            "mobile_position": "left-bottom"
        },
        "refer_customer_invite": {
            "popup_header": "10% Off For You And a Friend With MAHI",
            "popup_description": "Invite friends to try MAHI - get 10% off for a friend and earn 10% on every order you refer!\r\n\r\nWe'll notify you by email whenever you make a referral.",
            "button_text_get_invite": "Get invite link",
            "button_copy_invite": "Copy invite link",
            "popup_background_color": "#1d85e8",
            "popup_text_color": "#ffffff"
        },
        "refer_customer_incentive_popup": {
            "shop_header": "YOU'VE GOT 10% OFF",
            "shop_description": "Welcome to MAHI!\r\n\r\nYour 10% discount will be applied at checkout.",
            "shop_button_text": "Shop now",
            "shop_background_color": "#1d85e8",
            "shop_text_color": "#ffffff"
        }
    }
}